export enum Colorways {
  Default = "default",
  Families = "families",
  None = "",
  Moms = "moms",
  Learning = "learning",
  Pros = "pros",
}
